import { ITribes, ITribesAction, ITribesFormValue } from "@interfaces/ITribes";

export const mapValueToRequest = (values: ITribesFormValue): ITribesAction => {
    const { about } = values
    const data: ITribesAction = {
        about
    }

    return data;
}

export const mapDataToFieldsValue = (values: ITribes): ITribesFormValue => {
    const { about } = values
    const data = {
        about
    }
    return data
}